/**
 * Product media component
 *
 * @module product-media
 * @version 1.0.0
 * @extends HTMLElement
*/
customElements.component = 'product-media';

if(!customElements.get(customElements.component)) {

    class productMediaComponent extends HTMLElement {

        constructor() {
          super();
          this.media = this.querySelector('[data-media]');
          this.thumbnails = this.querySelector('[data-thumbnails-slider]');

          if(this.thumbnails){
            this.thumbnailsCells = this.thumbnails.querySelectorAll('[data-thumbnails-item]');
          }

          this.initCells();
          this.initSlider();
          this.initEvents();
          if(this.thumbnails){
            this.bindThumbnailToProductMedia();
          }
        }

        initCells() {
            this.cells = [];
            this.activeCells = 0;
            this.media.querySelectorAll('[data-media-item]').forEach(item => {
              let index = item.dataset.mediaItemIndex;
              this.cells[index] = {
                  index: parseInt(index),
                  status: true,
                  alt: item.dataset.mediaItem,
                  element: item,
                  mediaId: item.dataset.mediaItemId
              };
            });
        }

         /**
          * Init media slider.
          *
          * @returns {undefined}
        */
        initSlider() {
          this.querySelectorAll('.swiper-lazy-loading').forEach(element => {
            element.classList.remove('swiper-lazy-loading');
          });

          const swiperMediaPagination = this.media.querySelector('.swiper-media-pagination');
          const swiperScrollbar = this.media.querySelector('.swiper-scrollbar');

          const swiperButtonNext = this.media.querySelector('.swiper-button-next');
          const swiperButtonPrev = this.media.querySelector('.swiper-button-prev');

          let defaultOptions = {
            preloadImages: true,
            lazy: {
              loadPrevNext: true,
            },
            dynamicBullets: true,
            autoHeight: false,
            slidesPerView: 'auto',
            spaceBetween: 16,
            pagination: {
              el: swiperMediaPagination,
              dynamicBullets: true,
            },
            scrollbar: {
              el: swiperScrollbar,
            },
            navigation: {
              nextEl: swiperButtonNext,
              prevEl: swiperButtonPrev,
            },

            on: {
                init: () => {
                    if(!this.thumbnails) return false;
                },
                slideChange: () => {
                    if(!this.thumbnails) return false;
                    this.activeThumbnail();
                }
            }
        };
          let options = (this.dataset.options) ? JSON.parse(this.dataset.options) : {};
          this.options = {...defaultOptions, ...options};
          this.slider = new Swiper(this.media, this.options);
        }

        activeThumbnail(activeIndex = 0) {
         // const index = this.slider.activeIndex;
          this.thumbnails.slider.slideTo(activeIndex, 300);
          this.removeAllThumbnailsActive();
          this.thumbnails.slider.slides[activeIndex]?.classList.add("active");
        }

        removeAllThumbnailsActive() {
          this.thumbnails.slider.slides.forEach(slide => {
            slide.classList.remove("active");
          });
        }

        bindThumbnailToProductMedia() {
          this.thumbnailsItems = this.thumbnails.querySelectorAll('[data-thumbnails-item]');
          this.thumbnailsItems.forEach(thumbnailsItem => {
              thumbnailsItem.addEventListener('click', event => {
                event.preventDefault();
                let index = this.thumbnails.slider.clickedIndex;
                this.slider.slideTo(index, 300);
                this.activeThumbnail(index);
              }, false);
          });

          this.initPhotoSwipeEvents();
        }

        initEvents() {


          // On variant change hide non clickable variant
          window.addEventListener('variant-change', event => {
            if (event.detail.product.id ===  parseInt(this.dataset.productMediaId)) {
              this.swapImages(event.detail.product, event.detail.variant);
              this.removeClass();

              if (!event.detail.variant.featured_media) return;
              const elements =  document.querySelectorAll(`[alt="${event.detail.variant.featured_media.alt}"]`)

              if (elements.length > 0) {
                elements.forEach((element, index) => {
                  if (index === 1) {
                    element.parentElement.classList.add('active');
                  }
                });
              }
            }
          });
        }

        removeClass(){
          document.querySelectorAll('picture').forEach(element => {
            element.classList.remove('active');
          });
        }
        /**
         * Swap media images by variant.
         *
         * @param {object} product Product data.
         * @param {object} variant Variant data.
         * @returns {undefined}
        */
        swapImages(product, variant) {
          if (this.thumbnails) {
            this.thumbnails.slider.removeAllSlides();
          }

          let alt = this.getCurrentAlt(product, variant);

          if (alt && alt != product.title) {
            this.activeCells = 0;
            let disabledIndices = [];
            let selectedIndex = null;

            this.cells.forEach(cell => {

              if (cell.alt && cell.alt.toLowerCase() == alt) {
                this.enableImage(cell.index);
                this.slider.slideTo(cell.index, 20);
                //this.activeThumbnail();
              } else{

               //this.disableImage(cell.index);
               if (!cell.alt.toLowerCase().includes('variant')) {
                this.enableImage(cell.index);
                this.appendthumbnailImage(cell.index);

              } else {
                //this.deleteImage(cell.index);

              }

              }

            });

          } else if (variant.featured_media) {

            this.cells.forEach(cell => {
              if (parseInt(cell.mediaId) == parseInt(variant.featured_media.id)) {
                this.showAllImages();
                this.slider.slideTo(cell.index, 500);
              }
            });

          } else {
            this.showAllImages();

          }

          //this.initSlider();
          if (this.thumbnails) {
             this.activeThumbnail();
          }
        }


      /**
       * Get image alt from current variant active.
       *
       * @param {object} product Product data.
       * @param {object} variant Variant data.
       * @returns {string} Image alt.
      */
      getCurrentAlt(product, variant) {

        let currentAlt = null;

        if(product.images) {

            product.images.forEach((image, index) => {

              if(image.alt ==  product.title && variant) {

                this.enableImage(index);
              }
                if(image.alt && variant) {

                    let alt       = image.alt.toLowerCase(),
                        altArray  = alt.split('/'),
                        reference = (altArray[1]) ? altArray[1].trim() : null;

                    if(variant.title.toLowerCase().includes(reference) && !alt.includes('swatch')) {
                        currentAlt = alt;
                    }
                }
            });

            return currentAlt;
        }
      }

        /**
         * Destroy media slider.
         *
         * @returns {undefined}
        */
        destroySlider() {
          this.slider.destroy();
        }

        /**
         * Disable image by media cell index.'
         *
         * @param {integer} index Media cell index.
         * @returns {undefined}
        */
        disableImage(index) {

          this.cells[index].status = false;
        }

        deleteImage(index) {

          this.cells[index].status = false;

          let element = this.querySelector('[data-media-item-index="'+ index +'"]');

          if (element) {
            element.remove();
          }
      }


        /**
         * Enable image by media cell index.
         *
         * @param {integer} index Media cell index.
         * @returns {undefined}
        */
        enableImage(index) {

          if (this.cells[index]) {

            this.cells[index].status = true;

            if (!this.querySelector('[data-media-item-index="' + index + '"]')) {
                this.media.querySelector('[data-media-wrapper]').append(this.cells[index].element);
            }
            if(this.thumbnails){
              this.thumbnails.slider.appendSlide(this.thumbnailsCells[index]);
            }
          }
        }

        appendthumbnailImage(index) {
          this.cells[index].status = true;
          if(this.thumbnails){
            this.thumbnails.slider.appendSlide(this.thumbnailsCells[index]);
          }
      }

        /**
         * Show all media images.
         *
         * @returns {undefined}
        */

        showAllImages() {

          // Disable all images
          this.cells.forEach((cell, index) => {
              this.disableImage(index);
          });

          // Display all images except swatches
          this.cells.forEach((cell, index) => {
              if (cell.alt && cell.alt.toLowerCase().includes('variant')) {
                  this.disableImage(index);
              } else {
                  this.enableImage(index);
                  this.appendthumbnailImage(index);

              }

          });
        }

        getZoomImages() {
          const screenMode = window.screenMode;
          if(screenMode === "mobile") return document.querySelectorAll('[data-mobile-img]');
          else if (screenMode === "tablet") return document.querySelectorAll('[data-tablet-img]');
          else return document.querySelectorAll('[data-desktop-img]');
        }

        addZoomAnimation() {
          const zoomContainers = document.querySelectorAll('[data-zoom]');

          zoomContainers.forEach(container => {
            const image = container.querySelector('img');

            const applyZoomTransform = (e) => {
              const mouseX = e.clientX - container.getBoundingClientRect().left;
              const mouseY = e.clientY - container.getBoundingClientRect().top;
              const offsetX = (mouseX / container.clientWidth - 0.5) * 4;
              const offsetY = (mouseY / container.clientHeight - 0.5) * 4;

              const scale = 1.5;
              const translateX = -offsetX * 50;
              const translateY = -offsetY * 50;

              image.style.transform = `scale(${scale}) translate(${translateX}px, ${translateY}px)`;
            };

            const resetTransform = () => {
              image.style.transform = 'scale(1) translate(0, 0)';
            };

            container.addEventListener('mouseleave', resetTransform);
            container.addEventListener('mousemove', applyZoomTransform);
          });
        }

        initPhotoSwipeEvents() {

             // Init zoom image
             let zoomImage = document.querySelectorAll('[data-pswp-img]');

             if ("zoomOnHover" in this.dataset) this.addZoomAnimation();

             const pswpElement = document.querySelector('.pswp');

             if (pswpElement) this.initZoomImage(zoomImage);

             const bgoverlay = document.querySelector('.pswp__bg');

             bgoverlay?.addEventListener('click', () => {
               this.gallery.close();
             })

             // On screen change
             window.addEventListener('screen-breakpoint', event => {
              if (pswpElement) this.initZoomImage(zoomImage);
             });

             window.isScrolling = false;
             document.onscroll = event => {
                 window.isScrolling = true;
                 clearTimeout(window.scrollEndTimer)
                 window.scrollEndTimer = setTimeout( () => {
                     window.isScrolling = false;
                 }, 100)
             }
        }

        initFocusTrap ()  {
          this.focusTrap = focusTrap.createFocusTrap(this, { clickOutsideDeactivates: true });
        }

        activeFocusTrap ()  {
          if(this.focusTrap) this.focusTrap.activate();
        }

        disableFocusTrap() {
          if(this.focusTrap) this.focusTrap.deactivate();
        }

        initZoomFocusTrap(pswpElement) {
          if(pswpElement) {
            if(pswpElement.classList.contains("pswp--open")) {
              pswpElement.focusTrap = focusTrap.createFocusTrap(pswpElement, { clickOutsideDeactivates: true });
              if (pswpElement.focusTrap) {
                pswpElement.focusTrap.activate();
              }
            }
          }
        }

        initZoomImage(zoomImage) {

            if(window.screenMode == 'desktop' || window.screenMode == 'desktop-large' ) {
                //active on tablet, desktop and desktop-large devices by clicking the zoom button
                let zoomList = document.querySelectorAll('[data-zoom]');

                if(zoomList){
                    zoomList.forEach((zoomBtn) => {

                        if(zoomBtn && !zoomBtn.classList.contains('zoom-active') ){
                            zoomBtn.classList.add('zoom-active');

                            //init the zoom PhotoSwipe starting with the selected image
                            zoomBtn.addEventListener('click', (event) => {
                              if(window.isScrolling != true) {
                                document.body.classList.add('overflow-hidden');
                                let indexImg = zoomBtn.dataset.zoomImgIndex;
                                this.initPhotoSwipe(zoomImage, parseInt(indexImg));
                              }
                            });

                            zoomBtn.addEventListener('keydown', (event) => {
                              if (event.key === 'Enter') {
                                if(window.isScrolling != true) {
                                  document.body.classList.add('overflow-hidden');
                                  let indexImg = zoomBtn.dataset.zoomImgIndex;
                                  this.initPhotoSwipe(zoomImage, parseInt(indexImg));
                                }
                              }
                            });
                        }

                    });
                }

            } else {

                // active on mobile by clicking the image
                zoomImage.forEach((element, index) => {
                    if (!element.classList.contains('zoom-active')) {
                        element.classList.add('zoom-active');

                        //init the zoom PhotoSwipe starting with the selected image
                        element.addEventListener('click', (event) => {
                            this.initPhotoSwipe(zoomImage, parseInt(index));
                        });
                    }
                });
            }
        }


        isPswpDimensionsBelowTarget(pswpItem, targetDimensions) {
          const pswpWidth = Number(pswpItem.dataset.pswpWidth);
          const pswpHeight = Number(pswpItem.dataset.pswpHeight);
          return pswpWidth < targetDimensions.width && pswpHeight < targetDimensions.height;
        }

        updateSlideDimensions(slideObject, targetDimensions) {
          const sizeIncrement = targetDimensions.width - slideObject.w;
          slideObject.w += sizeIncrement;
          slideObject.h += sizeIncrement;
        }

        setSlideInfo(pswpItem) {
          const zoomLevel = 1500;
          const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          const targetDimensions = {
            width: viewportWidth + zoomLevel,
            height: viewportHeight + zoomLevel
          };
          const currentDimensions = {
            width: Number(pswpItem.dataset.pswpWidth),
            height: Number(pswpItem.dataset.pswpHeight)
          };
          const slideObject = {
            src: pswpItem.dataset.pswpSrc,
            w: currentDimensions.width,
            h: currentDimensions.height
          };

          if(this.isPswpDimensionsBelowTarget(pswpItem, targetDimensions)) this.updateSlideDimensions(slideObject, targetDimensions);

          return slideObject;
        }

        openPswpWrapper() {
          const pswpWrapper = document.getElementById("pswp-wrapper");
          pswpWrapper.classList.remove('hidden');
        }

        closePswpWrapper() {
          const pswpWrapper = document.getElementById("pswp-wrapper");
          pswpWrapper.classList.add('hidden');
        }

        initPhotoSwipe(pswpItems, startSlideIndex) {

          this.openPswpWrapper();

          const slides = [];

          pswpItems.forEach((pswpItem) => {
            slides.push(this.setSlideInfo(pswpItem));
          });

          const pswpElement = document.querySelector('#pswp-wrapper .pswp');

          const options = {
            tapToClose: true,
            fullscreenEl: true,
            shareEl: false,
            index: startSlideIndex,
            modal: false,
            focus: true
          };

          this.gallery = new PhotoSwipe( pswpElement, window.PhotoSwipeUI_Default, slides, options );

          this.gallery.listen('updateScrollOffset', (_offset) => {
            const r = pswpElement.getBoundingClientRect();
            _offset.x += r.left;
            _offset.y += r.top;
          });

          this.gallery.listen('close', () => {
            if(pswpElement.focusTrap) pswpElement.focusTrap.deactivate();
          });

          this.gallery.listen('destroy', () => {
            this.closePswpWrapper();
            document.body.classList.remove('overflow-hidden');
          });

          this.gallery.init();

          this.initZoomFocusTrap(pswpElement);
        }

    }

  customElements.define(customElements.component, productMediaComponent);
}
